export const drawRoundedRect = (
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  width: number,
  height: number,
  radius: number,
  corners?: {
    topLeft?: boolean;
    topRight?: boolean;
    bottomRight?: boolean;
    bottomLeft?: boolean;
  }
) => {
  // Default corners: all true (rounded)
  const c = {
    topLeft: corners?.topLeft !== false,
    topRight: corners?.topRight !== false,
    bottomRight: corners?.bottomRight !== false,
    bottomLeft: corners?.bottomLeft !== false,
  };

  ctx.beginPath();
  // Start at top-left corner
  if (c.topLeft && radius > 0) {
    ctx.moveTo(x + radius, y);
  } else {
    ctx.moveTo(x, y);
  }
  // Top edge
  if (c.topRight && radius > 0) {
    ctx.lineTo(x + width - radius, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
  } else {
    ctx.lineTo(x + width, y);
  }
  // Right edge
  if (c.bottomRight && radius > 0) {
    ctx.lineTo(x + width, y + height - radius);
    ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
  } else {
    ctx.lineTo(x + width, y + height);
  }
  // Bottom edge
  if (c.bottomLeft && radius > 0) {
    ctx.lineTo(x + radius, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
  } else {
    ctx.lineTo(x, y + height);
  }
  // Left edge
  if (c.topLeft && radius > 0) {
    ctx.lineTo(x, y + radius);
    ctx.quadraticCurveTo(x, y, x + radius, y);
  } else {
    ctx.lineTo(x, y);
  }
  ctx.closePath();
};
